/**
 * @module
 * @name Error
 */
export default {
  name: 'Error',
  computed: {
    showMaLogo: function () { return this.$maDomain },
    errorTitle: function () {
      if (this.$maDomain) {
        return this.$t('error.titleMA')
      } else {
        return this.$t('error.title')
      }
    }
  },
  methods: {
    /**
     * @function
     * @name routeBack
     * @description Push router to go to last route.
     */
    routerBack: function () {
      this.$router.go(-1)
    }
  }
}
